/**
 * NETWORK STATUS HOOK
 * 
 * React hook for monitoring network status
 */

import { useState, useEffect } from 'react';
import { networkStatus } from '../services/networkStatus';

/**
 * Hook to monitor network status
 */
export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(networkStatus.isOnline);

  useEffect(() => {
    const unsubscribe = networkStatus.subscribe((online) => {
      setIsOnline(online);
    });

    return unsubscribe;
  }, []);

  return {
    isOnline,
    isOffline: !isOnline,
  };
}

/**
 * Hook that executes callback when network status changes
 */
export function useNetworkStatusEffect(
  onOnline?: () => void,
  onOffline?: () => void
) {
  const { isOnline } = useNetworkStatus();

  useEffect(() => {
    if (isOnline && onOnline) {
      onOnline();
    } else if (!isOnline && onOffline) {
      onOffline();
    }
  }, [isOnline, onOnline, onOffline]);

  return { isOnline };
}
